import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { Trans, useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogTitle } from 'components/Dialog';
import { DialogContentText } from '@mui/material';
import getBrowserPermissionsDocLink from 'utils/getBrowserPermissionsDocLink';

const BlockedDevicesModal = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();
  const modalData = useAppSelector(selectActiveModalData);

  const hideModal = () => dispatch(closeModal('mediaDevicesBlocked'));

  const getMessageKey = () => {
    const { video = false, audio = false } = modalData || {};

    if (video && audio) {
      return 'devices_blocked.all_devices';
    }
    if (video) {
      return 'devices_blocked.video_devices';
    }
    if (audio) {
      return 'devices_blocked.audio_devices';
    }

    return 'devices_blocked.all_devices';
  };

  const messageKey = getMessageKey();

  return (
    <Dialog open aria-labelledby="devices-error-dialog" onClose={hideModal} maxWidth="xs">
      <DialogTitle id="devices-error-dialog" onClose={hideModal}>
        {t(`${messageKey}.title`)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans
            i18nKey={`modals:${messageKey}.description`}
            t={t}
            components={[
              // eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/anchor-has-content
              <a href={getBrowserPermissionsDocLink()} target="_blank" rel="noopener noreferrer" />,
            ]}
          />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default BlockedDevicesModal;
